// Vuex
import { MutationTree } from 'vuex'
// VuexFire
import { vuexfireMutations } from 'vuexfire'
import { State } from './state'

export default <MutationTree<State>>{
  setConnectionState(state, newConnectionState: boolean): void {
    state.onLine = newConnectionState
  },

  setUser(state: { user: unknown }, user: unknown): void {
    state.user = user
  },

  ...vuexfireMutations,
}
